import styled from 'styled-components'
import { Avatar, Icon } from 'antd'

import { Gender } from 'src/types'

interface Props {
  gender: Gender
}

const colors = {
  [Gender.F]: { bg: '#fff0f6', color: '#eb2f96' },
  [Gender.M]: { bg: '#d1dff3', color: '#467fcf' },
  [Gender.X]: { bg: '#fafafa', color: '#575757' }
}

export const Container = styled.div`
  display: initial;
  position: relative;
`

export const WrapIcon = styled(Icon)`
  position: absolute;
  right: 8;
  top: -16;
  z-index: 1;
`

export const WrapUserAvatar = styled(Avatar)<Props>`
  background-color: ${({ gender }) => colors[gender].bg};
  color: ${({ gender }) => colors[gender].color};
`
